import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
    html {
        /* font-size: 22px; */

        /* @media (max-width: 992px) {
            font-size: 13px;
        }
        @media (max-width: 576px) {
            font-size: 11px;
        } */
    }

    body {
        height: auto;
    }

    @media (min-width: 1200px) {
        .container {
            min-width: 978px;
        }
    }

    @media (min-width: 768px) {
        .hiddenDesktop  {
            display: none!important;
        }
    }
    @media (max-width: 767px) {
        .hiddenMobile  {
            display: none!important;
        }
    }

`
